export default "__VITE_ASSET__CSnSJvUE__"